"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogKind = exports.LoggerBase = void 0;
const cuid_1 = __importDefault(require("cuid"));
class LoggerBase {
    constructor() {
        this._correlationId = cuid_1.default();
    }
    get correlationId() {
        return this._correlationId;
    }
    debug(message, data) {
        this.writeLog(LogKind.DEBUG, message, data);
    }
    error(message, data) {
        this.writeLog(LogKind.ERROR, message, data);
    }
    info(message, data) {
        this.writeLog(LogKind.INFO, message, data);
    }
    log(message, data) {
        this.info(message, data);
    }
    warn(message, data) {
        this.writeLog(LogKind.WARN, message, data);
    }
}
exports.LoggerBase = LoggerBase;
var LogKind;
(function (LogKind) {
    LogKind["DEBUG"] = "DEBUG";
    LogKind["ERROR"] = "ERROR";
    LogKind["INFO"] = "INFO";
    LogKind["WARN"] = "WARN";
})(LogKind = exports.LogKind || (exports.LogKind = {}));
//# sourceMappingURL=LoggerBase.js.map